import _extends from "@babel/runtime/helpers/extends";
import _isNil from "lodash/isNil";
import _includes from "lodash/includes";

/* eslint-disable no-console */
import axios from 'axios';

/**
 * sample utlity function to convert number format based on country culture code- pending its implementation
 * @param {number} value
 * @param {string} cultureCode
 * @returns formatedNumber
 */
export const convertNumberFormat = (value, cultureCode = 'en-US') => {
  if (value === undefined) throw new Error('Number is required to return formatted number.');
  return new Intl.NumberFormat(cultureCode).format(value);
};
/**
 * sample utlity function to convert date format based on country culture code- pending its implementation
 * @param {date as string} value
 * @param {string} cultureCode
 * @returns formatedDate
 */

export const convertDateFormat = (value, cultureCode = 'en-US') => {
  if (value === undefined) throw new Error('Date is required to return formatted date');
  return new Intl.DateTimeFormat(cultureCode).format(value);
}; // TODO: Canada Team: Delete this function and use getLang instead once Eleanor is updated to accept culture codes
// Eleanor only accepts the culture Enum but a upcoming PR is refactoring Eleanor to accept culture codes instead of the culture enum.

const getCultureEnum = cultureCode => {
  const cultureCodeToCultureEnumMapping = {
    'en-US': '1',
    'en-CA': '2',
    'fr-CA': '3'
  };
  let cultureValue = cultureCodeToCultureEnumMapping[cultureCode];

  if (_isNil(cultureValue)) {
    console.log(`unknown culture selected: <${cultureCode}>... Defaulting to en-US...`);
    cultureValue = 1;
  }

  return cultureValue;
}; // This no-unused-vars is temporary until getCultureEnum is deleted. see comment above getCultureEnum function.
// eslint-disable-next-line no-unused-vars


const getLang = cultureCode => {
  const supportedCultureCodes = ['en-US', 'en-CA', 'fr-CA'];

  if (!_includes(supportedCultureCodes, cultureCode)) {
    console.log(`culture code <${cultureCode}> not supported. Defaulting to en-US.`);
    return supportedCultureCodes[0];
  }

  return cultureCode;
};

export const getShortLang = cultureCode => {
  const cultureMapping = {
    'en-CA': 'en',
    'en-US': 'en',
    'fr-CA': 'fr'
  };
  return cultureMapping[cultureCode];
};
export const appendCultureToEleanorRequests = currentCulture => {
  axios.interceptors.request.use(config => {
    // eslint-disable-next-line no-param-reassign
    config.params = _extends({}, config.params, {
      culture: getCultureEnum(currentCulture)
    });
    return config;
  });
};